import styled from 'styled-components';

const SignUpWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const SignUpHeading = styled.h2`
  text-align: center;
  font-family: lato !important;
  font-weight: bold !important;
  font-size: 24px !important;
  margin-bottom: 1.5em;
`;

export { SignUpWrapper, SignUpHeading };
